<script setup lang="ts">
import type { CmsElementNetzpBlog6 } from "~/composables/useCustom";
import { ref, computed } from "vue";

const props = defineProps<{
  content: CmsElementNetzpBlog6;
}>();

const data = props.content?.data || {};
const config = props.content?.config || {};
const initialListing = data.result || { elements: [], total: 0 };
const currentPage = ref(1);
const itemsPerPage = ref(24); // Adjust this number as needed
const loadedCount = ref(0);
// // Computed property to show limited number of newss
const displayedNews = computed(() => {
  loadedCount.value = currentPage.value * itemsPerPage.value;
  return initialListing.elements.slice(0, loadedCount.value);
});

function loadMore() {
  currentPage.value += 1;
}



</script>
<template>
  <div class="product-wrap px-4 mt-10">
    <div class="container mx-auto relative pb-12 sm:pb-16">
      <div
        v-if="displayedNews.length > 0"
        class="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8 mb-12"
      >
        <template
          v-for="(news, index) in displayedNews"
          :key="news.id || index"
        >
          <CommonBlogBox :news="news" />
        </template>
      </div>
      <div v-else class="text-center text-davy-grey">
        {{ $t("news.noNews") }}
      </div>

      <template v-if="loadedCount < initialListing.elements.length">
        <div class="show-more text-center mb-5">
          <button
            id="show-more"
            class="btn-default btn-transprent-bg bg-transparent"
            @click="loadMore"
          >
            {{ $t("news.loadMore") }}
          </button>
        </div>
        <!-- Progress bar itself -->
        <div class="progress shown w-full md:w-[360px] mx-auto truncate">
          <div class="w-full bg-platinum h-[6px] rounded mb-5 relative">
            <div
              id="progress-bar"
              class="bg-arsenic h-[4px] rounded absolute top-1/2 inset-y-1/2 mt-[-2px]"
              :style="{
                width: `${(loadedCount / initialListing.elements.length) * 100}%`,
              }"
            ></div>
          </div>
          <div
            class="progress-shown flex items-center justify-center text-sm font-semibold text-davy-grey space-x-2"
          >
            <div id="progress-text">
              {{ loadedCount }} {{ $t("product.load.of") }}
              {{ initialListing.elements.length }}
            </div>
            <span>{{ $t("product.load.shown") }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
